// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
import { SVGProps } from 'react';

const SvgHamburgerRest16 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 16 16"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M2 3.75c0-.414.298-.75.667-.75h10.666c.368 0 .667.336.667.75s-.299.75-.667.75H2.667C2.298 4.5 2 4.164 2 3.75ZM2 8c0-.414.298-.75.667-.75h10.666c.368 0 .667.336.667.75s-.299.75-.667.75H2.667C2.298 8.75 2 8.414 2 8Zm.667 3.5c-.369 0-.667.336-.667.75s.298.75.667.75h10.666c.368 0 .667-.336.667-.75s-.299-.75-.667-.75H2.667Z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgHamburgerRest16;
